<div class="supplier-tabs" [formGroup]="form">
  <div class="form-group">
    <label class="col-md-4 control-label">S2S Callbacks</label>
    <div class="col-md-6">
      <label class="radio-inline">
        <input
          type="radio"
          name="iss2sCallback"
          id="iss2sCallback"
          [value]="true"
          formControlName="iss2sCallback"
        />
        Yes
      </label>
      <label class="radio-inline">
        <input
          type="radio"
          name="iss2sCallback"
          [value]="false"
          formControlName="iss2sCallback"
        />
        No
      </label>
    </div>
  </div>

  <div class="form-group">
    <label class="control-label col-md-4">Complete to Non-Complete</label>
    <div class="col-md-6">
      <input
        name="isCompleteToNonCompleteURL"
        type="text"
        placeholder="Complete to Non-Complete"
        class="form-control input-md"
        formControlName="isCompleteToNonCompleteURL"
      />
    </div>
  </div>

  <div class="form-group">
    <label class="control-label col-md-4">Non-Complete to Complete</label>
    <div class="col-md-6">
      <input
        name="isNonCompleteToCompleteURL"
        type="text"
        placeholder="Non-Complete to Complete"
        class="form-control input-md"
        formControlName="isNonCompleteToCompleteURL"
      />
    </div>
  </div>

  <div class="form-group" [hidden]="true">
    <label class="control-label col-md-4">S2S Postback - Complete</label>
    <div class="col-md-6">
      <input
        name="s2sCompleteCallbackURL"
        type="text"
        placeholder="S2S Complete Callback URL"
        class="form-control input-md"
        formControlName="s2sCompleteCallbackURL"
      />
    </div>
  </div>

  <div class="form-group">
    <label class="control-label col-md-4">S2S Postback - Microreward</label>
    <div class="col-md-6">
      <input
        name="s2sMicroRewardCallbackURL"
        type="text"
        placeholder="S2S Microreward Callback URL"
        class="form-control input-md"
        formControlName="s2sMicroRewardCallbackURL"
      />
    </div>
  </div>
</div>
